import { useState, useEffect, useRef } from 'react';
import './style.css';
import AlertMessage from '../../Alert';
import { Main } from '../../Main';
import { Title } from '../../Title';
import { Button, Card, Col, Modal as Modals, Row, Modal as ModalBoot, Form, Spinner } from 'react-bootstrap';
import { Label } from '../../Label';
import api from '../../../services/api';
import { Autocomplete, Modal, Box, LinearProgress, TextField, Typography, Tooltip } from '@mui/material';
import { FormGroup } from '../../FormGroup';
import { Options, Select } from '../../Select';
import { useNavigate } from 'react-router-dom';
import { Height, Refresh } from '@mui/icons-material';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import { io } from 'socket.io-client';
import { DocumentoEmpresa } from '../DocumentoEmpresa';
import { CardContent } from '../../CardContent';



interface AsoRapidoProps {
    trabalhadorSelecionado: any | null;
    empresa: any | null;
    cnae: any | null;
}

export const AsoRapido: React.FC<AsoRapidoProps> = ({ trabalhadorSelecionado, empresa, cnae }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [trabalhadores, setTrabalhadores] = useState([]);
    const [trabalhador, setTrabalhador] = useState([]);
    const [funcao, setFuncao] = useState([]);
    const [funcoes, setFuncoes] = useState([]);
    const [examesCadastrados, setExamesCadastrados] = useState([]);
    const [examesExcluidos, setExamesExcluidos]: any = useState([]);
    const [riscos, setRiscos] = useState([]);
    const [funcaoSelecionada, setFuncaoSelecionada]: any = useState(null);
    const [funcoesTrabalhador, setFuncoesTrabalhador]: any = useState([])
    const [riscoSelecionado, setRiscoSelecionado]: any = useState(null);
    const [nomeFdt, setNomeFdt]: any = useState('');
    const [nomeGhe, setNomeGhe]: any = useState('');
    const [uf, setUf]: any = useState('');
    const [crm, setCRM]: any = useState('');
    const [nomeMedico, setNomeMedico]: any = useState('');
    const [tipoConsulta, setTipoConsulta]: any = useState('');
    const [trabalhoAltura, setTrabalhoAltura]: any = useState('');
    const [trabalhoConfinado, setTrabalhoConfinado]: any = useState('');
    const [riscosIncluidos, setRiscosIncluidos]: any = useState([]);
    const [show, setShow] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [error, setError] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [valorInicialTotal, setValorInicialTotal] = useState(0);
    const [cupom, setCupom] = useState<any>();
    const [cuponsAtivos, setCuponsAtivos] = useState(false);
    const [descontoTotal, setDescontoTotal] = useState(false);
    const [redirectCounter, setRedirectCounter] = useState(5);
    const [paymentApproved, setPaymentApproved] = useState(false);
    const [openPdfModal, setOpenPdfModal] = useState(false);
    const handleClose = () => setShow(false);
    const [progressValue, setProgressValue] = useState(0);
    const [qrCode, setQrCode] = useState("");
    const [categorias, setCategorias] = useState([])
    const [categoriaSelecionada, setCategoriaSelecionada]: any = useState()
    const [nomeRisco, setNomeRisco]: any = useState()

    useEffect(() => {
        const socket = io(`${process.env.REACT_APP_SOCKET_URL}`, { transports: ['websocket', 'polling'] });

        socket.on('paymentStatusUpdated', (data: any) => {
            if (data.status === 'approved') {
                setPaymentApproved(true);
                handleSavePayment(data, empresa.id_usuario);
            }
        });

        return () => {
            socket.off('paymentStatusUpdated');
        };
    }, []);

    const handleSavePayment = async (data: any, userId: any) => {
        try {
            data.userId = userId;
            await api.post('salvar-pagamento-reaproveitamento', data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (trabalhadorSelecionado) {
            fetchExams()
            handleListCategory()
            fetchCupons()
        }
    }, [trabalhadorSelecionado]);


    const tipos = [
        { id: 1, nome: 'APTO' },
        { id: 2, nome: 'INAPTO' },
        { id: 3, nome: 'NÃO SE APLICA' }
    ];

    const tiposconsulta = [
        { id: 1, nome: 'ADMISSIONAL' },
        { id: 2, nome: 'PERIÓDICO' }
    ];

    const ufs = [
        { id: 1, nome: 'AC' },
        { id: 2, nome: 'AL' },
        { id: 3, nome: 'AM' },
        { id: 4, nome: 'AP' },
        { id: 5, nome: 'BA' },
        { id: 6, nome: 'CE' },
        { id: 7, nome: 'DF' },
        { id: 8, nome: 'ES' },
        { id: 9, nome: 'GO' },
        { id: 10, nome: 'MA' },
        { id: 11, nome: 'MG' },
        { id: 12, nome: 'MS' },
        { id: 13, nome: 'MT' },
        { id: 14, nome: 'PA' },
        { id: 15, nome: 'PB' },
        { id: 16, nome: 'PE' },
        { id: 17, nome: 'PI' },
        { id: 18, nome: 'PR' },
        { id: 19, nome: 'RJ' },
        { id: 20, nome: 'RN' },
        { id: 21, nome: 'RO' },
        { id: 22, nome: 'RR' },
        { id: 23, nome: 'RS' },
        { id: 24, nome: 'SC' },
        { id: 25, nome: 'SE' },
        { id: 26, nome: 'SP' },
        { id: 27, nome: 'TO' }
    ];

    useEffect(() => {
        const calcularValorInicial = () => {
            const somaValores = parseFloat(examesCadastrados
                .reduce((total: number, exame: { valor_total: number }) => total + exame.valor_total / 100, 0)
                .toFixed(2));
            setValorInicialTotal(somaValores);
        };

        // Apenas calcula o valor inicial na primeira carga
        if (examesCadastrados.length > 0 && valorInicialTotal === 0) {
            calcularValorInicial();
        }
    }, [examesCadastrados]);

    useEffect(() => {
        if (paymentApproved) {
            const progressTimer = setInterval(() => {
                setProgressValue((oldValue) => {
                    const newValue = oldValue + 1;
                    if (newValue === 100) {
                        clearInterval(progressTimer);
                        const redirectTimer = setInterval(() => {
                            setRedirectCounter((counter) => {
                                if (counter === 1) {
                                    clearInterval(redirectTimer);
                                    handleOpenPdf();
                                }
                                return counter - 1;
                            });
                        }, 1000);
                    }
                    return newValue;
                });
            }, 100);
        }
    }, [paymentApproved]);


    const fetchExams = async () => {
        try {
            const response = await api.post(`buscar-exames-trabalhador/${trabalhadorSelecionado.id}/${empresa.id}`);
            setExamesCadastrados(response.data.examesTrabalhadorAtual);
            setFuncoesTrabalhador(response.data.funcoesTrabalhador)
            setExamesExcluidos([])
        } catch (error) {
            console.error('Erro ao buscar dados iniciais', error);
            setAlert({ show: true, message: 'Erro ao buscar dados iniciais. Tente novamente!', variant: 'danger' });
        }
    }

    const handlePayment = async () => {
        try {
            let focusSet = false;

            // Verifica se algum dos campos obrigatórios está vazio
            if (!funcaoSelecionada) {
                if (!focusSet) {
                    const input = document.getElementById('funcaoSelecionada') as HTMLInputElement;
                    if (input) input.focus();
                    focusSet = true;
                }
            } else if (tipoConsulta === '') {
                if (!focusSet) {
                    const input = document.getElementById('tipoConsulta') as HTMLInputElement;
                    if (input) input.focus();
                    focusSet = true;
                }
            } else if (trabalhoAltura === '') {
                if (!focusSet) {
                    const input = document.getElementById('trabalhoAltura') as HTMLInputElement;
                    if (input) input.focus();
                    focusSet = true;
                }
            } else if (trabalhoConfinado === '') {
                if (!focusSet) {
                    const input = document.getElementById('trabalhoConfinado') as HTMLInputElement;
                    if (input) input.focus();
                    focusSet = true;
                }
            }

            // Se algum campo estava vazio, exibe um alerta geral e sai da função
            if (!funcaoSelecionada || tipoConsulta === '' || trabalhoAltura === '' || trabalhoConfinado === '') {
                setAlert({
                    show: true,
                    message: "Por favor, preencha todos os campos obrigatórios.",
                    variant: "warning",
                });
                return;
            }

            // Se houver desconto total
            if (descontoTotal) {
                setPaymentApproved(true);
                handleOpenPdf();
            } else {
                // Se não houver desconto total, segue para os detalhes de pagamento
                const paymentDetails = {
                    transaction_value: valorInicialTotal,
                    description: 'Pagamento de Reaproveitamento ASO Rápido',
                    email: 'comercial@medicoatento.com.br', //TODO: Alterar email para gerar pagamento.
                    cpf: 'xxx.xxx.xxx-xx',
                };
                const response = await api.post('/pix/create', paymentDetails);
                setQrCode(response.data.qr_code_base64);
                setShow(true);
            }
        } catch (error) {
            console.error('Erro ao criar pagamento PIX:', error);
        }
    };

    const handleListFunction = async (inputValue: any) => {
        if (inputValue.length > 3) {
            const response = await api.get(`funcionarios/buscar-funcao/${inputValue}`);
            const responseData = response.data;
            setFuncoes(responseData);
        } else {
            setFuncoes([]);
        }
    };

    const handleOpenPdf = async () => {
        setOpenPdfModal(true);
    };

    const handleClosePdf = async () => {
        setOpenPdfModal(false)
    }

    const handleSelectConfinado = (tipo: any) => {
        setTrabalhoConfinado(tipo)
    }

    const handleSelectAltura = (tipo: any) => {
        setTrabalhoAltura(tipo)
    }

    const handleSelectCategoria = (categoria: any) => {
        setCategoriaSelecionada(categoria)
    }

    const handleSelectConsulta = (tipo: any) => {
        setTipoConsulta(tipo)
    }

    const handleSelectUf = (uf: any) => {
        setUf(uf)
    }

    const handleRemoverExame = (index: number, nomeExame: string) => {
        if (nomeExame === "AVALIAÇÃO CLÍNICA") {
            setAlert({
                show: true,
                message: 'AVALIAÇÃO CLÍNICA não pode ser excluído',
                variant: 'danger'
            });
        } else {
            setExamesCadastrados((prevExames: any) => {
                const exameRemovido = prevExames[index];
                const novosExames = prevExames.filter((_: any, i: number) => i !== index);
                setExamesExcluidos((prevExcluidos: any) => [...prevExcluidos, exameRemovido]);
                return novosExames;
            });
        }
    };

    const handleIncluirRisco = () => {
        const categoria: any = categorias.find((cat: any) => cat.id === parseInt(categoriaSelecionada));

        if (!categoria) {
            setAlert({ show: true, message: 'Categoria selecionada é inválida!', variant: 'warning' });
            return;
        }

        const novoRisco = {
            nome: nomeRisco,
            AteBaseRiscosCat: categoria
        };

        if (!riscosIncluidos.some((r: any) => r.nome === novoRisco.nome && r.AteBaseRiscosCat.id === novoRisco.AteBaseRiscosCat.id)) {
            setRiscosIncluidos((prevRiscos: any) => [...prevRiscos, novoRisco]);
            setNomeRisco('');
        } else {
            // Exibe uma mensagem de alerta se o risco já estiver incluído
            setAlert({ show: true, message: 'Risco já incluído!', variant: 'warning' });
        }
    };


    const handleRemoverRisco = (index: any) => {
        setRiscosIncluidos((prevRiscos: any) => prevRiscos.filter((_: any, i: any) => i !== index));
    };

    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const handleListRisk = async (inputValue: any) => {
        if (inputValue.length > 3) {
            try {
                const encodedValue = encodeURIComponent(inputValue);
                const response = await api.get(`buscar-riscos/${encodedValue}`);
                setRiscos(response.data);
            } catch (error) {
                console.error('Erro ao buscar riscos', error);
                setAlert({ show: true, message: 'Erro ao buscar riscos. Tente novamente!', variant: 'danger' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setRiscos([]);
        }
    };


    const handleListCategory = async () => {
        try {
            const response = await api.get('buscar-categorias-riscos');
            const responseData = response.data;

            const formattedData = responseData.map((item: { id: number; categoria: string }) => ({
                id: item.id,
                categoria: item.categoria
            }));

            setCategorias(formattedData);
        } catch (error) {
            console.error('Erro ao buscar categorias', error);
            setAlert({ show: true, message: 'Erro ao buscar categorias. Tente novamente!', variant: 'danger' });
        } finally {
            setIsLoading(false);
        }
    };

    const calcularNovoPreco = (preco: number, desconto: number): number => {
        const novoPreco = (preco * (1 - desconto / 100));
        return novoPreco < 0 ? 0 : novoPreco;
    };

    const fetchCupons = async () => {
        const cupons = await api.get('listar-cupons');
        if (Array.isArray(cupons.data) && cupons.data.length > 0) {
            const cuponsAtivos = cupons.data.filter((cupom: any) => !cupom.desativado);
            if (cuponsAtivos.length > 0) setCuponsAtivos(true);
        }
    }

    const handleSearchCupom = async () => {
        try {
            if (!funcaoSelecionada || tipoConsulta == '' || trabalhoAltura == '' || trabalhoConfinado == '') {
                setError(true);
                setShowErrorModal(true)
                return;
            }
            const response = await api.post(`buscar-cupom-por-nome/${cupom}`);
            if (response.status === 200 && response.data) {
                if (response.data.cupom && response.data.cupom.desconto) {
                    const { desconto, id: cupomId } = response.data.cupom;
                    if (valorInicialTotal) {
                        const novoPreco: any = calcularNovoPreco(valorInicialTotal, desconto);
                        if (novoPreco === 0) setDescontoTotal(true);
                        setValorInicialTotal(novoPreco);
                    }
                    await api.post(`cupons/desativar/${cupomId}`);
                    setAlert({ show: true, message: response.data.message, variant: 'success' });
                }
            } else {
                setAlert({ show: true, message: response.data.message || 'Cupom inválido ou expirado.', variant: 'danger' });
            }
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setAlert({ show: true, message: error.response.data.message, variant: 'danger' });
            } else {
                setAlert({ show: true, message: 'Erro ao buscar o cupom.', variant: 'danger' });
            }
            console.log(error);
        }
    }

    const handleCloseErrorModal = () => setShowErrorModal(false);

    return (
        <>
            <div style={{
                display: 'flex',
                height: 'auto',
                padding: '10px'
            }}>
                <CardContent>
                    <h5 style={{ color: '#0463C1', marginBottom: '20px' }}>
                        3º - Preencha as informações do trabalhador:
                    </h5>
                    <Title text="Cadastrar Reaproveitamento Rápido" />
                    <Row style={{ marginTop: '20px' }}>
                        <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Informações do Trabalhador(a)</h6>
                    </Row>
                    <Row style={{ display: 'flex', flexDirection: 'row' }}>
                        <Col xs={12} md={6} xl={6}>
                            <Label title='Trabalhador (a)' htmlFor={''} />
                            <Autocomplete
                                value={trabalhadorSelecionado}
                                noOptionsText="Digite e selecione"
                                disabled
                                style={{ width: '100%', height: '50px', marginTop: '5px' }}
                                getOptionLabel={(option: any) => option ? option.nome : ""}
                                renderInput={(params) => <TextField {...params} label="" />}
                                options={trabalhadores.length > 0 ? trabalhadores : trabalhador}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        </Col>
                        <Col xs={12} md={6} xl={6}>
                            <span style={{ color: '#DA0606' }}>*</span><Label title='Função' htmlFor={''} />
                            <Autocomplete
                                id="funcaoSelecionada"
                                value={funcaoSelecionada}
                                onChange={(event, newValue) => {
                                    event.preventDefault();
                                    setFuncaoSelecionada(newValue);
                                    setError(false); // Limpa o erro se o valor for selecionado
                                }}
                                onInputChange={(event, newInputValue) => {
                                    event.preventDefault();
                                    handleListFunction(newInputValue);
                                }}
                                noOptionsText="Digite e selecione"
                                style={{ height: '50px', marginTop: '5px' }}
                                getOptionLabel={(option: any) => option ? option.nome : ""}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label=""
                                    />
                                )}
                                options={funcoes.length > 0 ? funcoes : funcao}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                className={!trabalhadorSelecionado ? 'autocomplete-disabled' : ''}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '20px' }}>
                        {trabalhadorSelecionado && (
                            <Col xs={12}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: '15px', color: '#0463C1' }}>
                                        Funções sugeridas
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        {funcoesTrabalhador.map((funcao: any, index: any) => (
                                            <div key={index} style={{
                                                backgroundColor: '#e0e0e0',
                                                borderRadius: '10px',
                                                padding: '3px 6px',
                                                margin: '3px',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                fontSize: '12px'
                                            }}>
                                                {funcao.nome}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                    {trabalhadorSelecionado && (
                        <>
                            <Row style={{ marginTop: '50px' }}>
                                <hr style={{ width: '100%' }}></hr>
                                <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Informações da Frente de Trabalho e Consulta</h6>
                            </Row>
                            <Row>
                                <Col xs={12} md={3} xl={3}>
                                    <FormGroup>
                                        <span style={{ color: '#DA0606' }}></span><Label title='Nome da Nova Frente de Trabalho' htmlFor={''} />
                                        <input
                                            type="text"
                                            id="fdt"
                                            placeholder="Digite o nome do FDT"
                                            value={nomeFdt}
                                            onChange={(e) => {
                                                setNomeFdt(e.target.value);
                                            }}
                                            style={{ width: '100%' }} />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={3} xl={3}>
                                    <FormGroup>
                                        <span style={{ color: '#DA0606' }}></span><Label title='Nome do GHE' htmlFor={''} />
                                        <input
                                            type="text"
                                            id="fdt"
                                            placeholder="Digite o nome do GHE"
                                            value={nomeGhe}
                                            onChange={(e) => {
                                                setNomeGhe(e.target.value);
                                            }}
                                            style={{ width: '100%' }} />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={2} xl={2}>
                                    <FormGroup>
                                        <span style={{ color: '#DA0606' }}>*</span><Label title='Tipo de Consulta' htmlFor={''} />
                                        <Select id="tipoConsulta" value={tipoConsulta} onSelect={handleSelectConsulta}>
                                            {tiposconsulta.map((tipo: any) => (
                                                <Options
                                                    key={tipo.id}
                                                    value={tipo.id}
                                                    name={tipo.nome} />
                                            ))}
                                        </Select>
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={2} xl={2}>
                                    <FormGroup>
                                        <span style={{ color: '#DA0606' }}>*</span><Label title='Trabalho em Altura' htmlFor={''} />
                                        <Select id="trabalhoAltura" value={trabalhoAltura} onSelect={handleSelectAltura}>
                                            {tipos.map((tipo: any) => (
                                                <Options
                                                    key={tipo.id}
                                                    value={tipo.id}
                                                    name={tipo.nome} />
                                            ))}
                                        </Select>
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={2} xl={2}>
                                    <FormGroup>
                                        <span style={{ color: '#DA0606' }}>*</span><Label title='Trabalho em Espaço Confinado' htmlFor={''} />
                                        <Select id="trabalhoConfinado" value={trabalhoConfinado} onSelect={handleSelectConfinado}>
                                            {tipos.map((tipo: any) => (
                                                <Options
                                                    key={tipo.id}
                                                    value={tipo.id}
                                                    name={tipo.nome} />
                                            ))}
                                        </Select>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '50px' }}>
                                <hr style={{ width: '100%' }}></hr>
                                <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Informações dos Exames Médicos</h6>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} xl={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <Row style={{ marginTop: '30px' }}>
                                        <h6 style={{ color: '#808080', textAlign: 'center' }}>Exames Incluídos</h6>
                                    </Row>
                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Ordem</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Exame</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Valor</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>
                                                        <Refresh onClick={fetchExams}
                                                            style={{
                                                                cursor: 'pointer',
                                                                fontSize: '1.5rem',
                                                            }}>
                                                        </Refresh></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {examesCadastrados.map((exame: any, index: number) => {
                                                    return (
                                                        <tr key={exame.id}>
                                                            <td style={{ fontSize: '15px', textAlign: 'center' }}>
                                                                <div>{index + 1}</div>
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {exame.ateBaseExames.nome}
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {transformarPreco(exame.valor_total)}
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                <button
                                                                    style={{ backgroundColor: 'red', color: 'white', border: 'none', borderRadius: '5px', width: '25%' }}
                                                                    onClick={() => handleRemoverExame(index, exame.ateBaseExames.nome)}
                                                                >
                                                                    x
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Row>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '20px', textAlign: 'center', fontWeight: 'bold' }}>
                                {examesCadastrados.length > 0 && (
                                    <h5>Total: R$ {descontoTotal ? '0,00' : valorInicialTotal}</h5>
                                )}
                            </Row>
                            <Row style={{ marginTop: '50px' }}>
                                <hr style={{ width: '100%' }}></hr>
                                <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Informações dos Riscos Ocupacionais</h6>
                            </Row>
                            <Row>
                                <Col xs={12} md={4} xl={4}>
                                    <Row style={{ marginTop: '30px' }}>
                                        <h6 style={{ color: '#808080', textAlign: 'center' }}>Incluir Risco</h6>
                                    </Row>
                                    <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Col xs={12} md={4}>
                                            <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                                <Label title='Categoria' htmlFor='categoriaSelecionada' />
                                                <Select
                                                    id="categoriaSelecionada"
                                                    value={categoriaSelecionada}
                                                    onSelect={handleSelectCategoria}
                                                    style={{ height: '50px', width: '100%' }}
                                                >
                                                    {categorias.map((categoria: any) => (
                                                        <Options
                                                            key={categoria.id}
                                                            value={categoria.id}
                                                            name={categoria.categoria}
                                                        />
                                                    ))}
                                                </Select>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ color: '#DA0606' }}></span>
                                                <Label title='Nome' htmlFor='nomeRisco' />
                                                <input
                                                    type="text"
                                                    id="nomeRisco"
                                                    placeholder="Digite o nome do Risco"
                                                    value={nomeRisco}
                                                    onChange={(e: any) => setNomeRisco(e.target.value)}
                                                    style={{ width: '100%', height: '48px' }} // Ajuste a altura
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                                <button
                                                    style={{ width: '100%', height: '48px', border: 'none', backgroundColor: '#0575E6', color: 'white', borderRadius: '3px', fontSize: '16px', marginTop: '24px' }} // Ajuste a altura e a largura
                                                    onClick={() => handleIncluirRisco()}
                                                >
                                                    + Incluir
                                                </button>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} md={1} xl={1} className='column'>
                                    <div className="vertical-line"></div>
                                </Col>
                                <Col xs={12} md={7} xl={7}>
                                    <Row style={{ marginTop: '30px' }}>
                                        <h6 style={{ color: '#808080', textAlign: 'center' }}>Riscos Incluídos</h6>
                                    </Row>
                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '3px', border: '1px solid #0d6efd', marginTop: '20px' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white', height: '48px' }}>
                                                    <th style={{ fontSize: '14px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Ordem</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Categoria</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Risco</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {riscosIncluidos.map((risco: any, index: number) => {
                                                    return (
                                                        <tr key={risco.id}>
                                                            <td style={{ fontSize: '12px', textAlign: 'center' }}>
                                                                <div>{index + 1}</div>
                                                            </td>
                                                            <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px' }}>
                                                                {risco.AteBaseRiscosCat.categoria}
                                                            </td>
                                                            <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px' }}>
                                                                {risco.nome}
                                                            </td>
                                                            <td style={{ fontSize: '12px', textAlign: 'center', padding: '6px' }}>
                                                                <button
                                                                    style={{ backgroundColor: 'red', color: 'white', border: 'none', borderRadius: '5px', width: '90%' }}
                                                                    onClick={() => handleRemoverRisco(index)}
                                                                >
                                                                    x
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Row>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '50px' }}>
                                <hr style={{ width: '100%' }}></hr>
                                <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Informações do Médico Coordenador</h6>
                            </Row>
                            <Row>
                                <Col xs={12} md={4} xl={4}>
                                    <FormGroup>
                                        <Label title='Nome do Médico' htmlFor={''} />
                                        <input type='text' style={{ width: '100%' }} value={nomeMedico} onChange={(e: any) => setNomeMedico(e.target.value)} />
                                    </FormGroup>

                                </Col>
                                <Col xs={12} md={4} xl={4}>
                                    <FormGroup>
                                        <Label title='CRM do Médico' htmlFor={''} />
                                        <input type='text' style={{ width: '100%' }} value={crm} onChange={(e: any) => setCRM(e.target.value)} />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={4} xl={4}>
                                    <Label title='UF CRM do Médico' htmlFor={''} />
                                    <Select id="selectResponsavel" value={uf} onSelect={handleSelectUf}>
                                        {ufs.map((tipo: any) => (
                                            <Options
                                                key={tipo.id}
                                                value={tipo.nome}
                                                name={tipo.nome} />
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                            {cuponsAtivos && (
                                <Row>
                                    <hr style={{ width: '100%', marginTop: '50px', marginBottom: '50px' }}></hr>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                        <h6 style={{ marginBottom: '15px' }}>Se você possui um cupom de desconto, insira-o aqui para aproveitar o desconto!</h6>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
                                            <input
                                                type="text"
                                                id="nome"
                                                placeholder="Digite o Código"
                                                value={cupom}
                                                onChange={(e) => setCupom(e.target.value.toUpperCase())}
                                                style={{ width: '145px', height: '50px', border: '1px solid lightgray', borderRadius: '3px', fontSize: '13px', padding: '10px' }}
                                            />
                                            <Button
                                                style={{ backgroundColor: '#02298A', color: 'white', border: 'none', borderRadius: '5px', height: '40px' }}
                                                onClick={handleSearchCupom}>
                                                Aplicar
                                            </Button>
                                        </div>
                                    </div>
                                    <hr style={{ width: '100%', marginTop: '50px' }}></hr>
                                </Row>
                            )}
                            <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '50px' }}>
                                <button
                                    style={{ width: '8%', height: '30px', border: 'none', borderRadius: '5px', backgroundColor: '#4CAA1D', color: 'white' }}
                                    onClick={handlePayment}
                                >
                                    <AttachEmailIcon style={{ fontSize: '16px', marginRight: '7px' }} />
                                    Enviar
                                </button>
                            </Row>


                            {openPdfModal && (
                                <DocumentoEmpresa
                                    tipoConsulta={tipoConsulta}
                                    trabalhadorSelecionado={trabalhadorSelecionado}
                                    empresa={empresa}
                                    funcaoSelecionada={funcaoSelecionada}
                                    nomeGhe={nomeGhe}
                                    nomeFdt={nomeFdt}
                                    riscosIncluidos={riscosIncluidos}
                                    examesCadastrados={examesCadastrados}
                                    examesExcluidos={examesExcluidos}
                                    nomeMedico={nomeMedico}
                                    crm={crm}
                                    uf={uf}
                                    trabalhoAltura={trabalhoAltura}
                                    trabalhoConfinado={trabalhoConfinado}
                                    descontoTotal={descontoTotal}
                                    valorInicialTotal={valorInicialTotal}
                                    onClose={handleClosePdf}
                                    dadosCnae={cnae}
                                />
                            )}



                            <Modals show={show} onHide={handleClose} size='lg'>
                                <Modals.Header closeButton>
                                    <Modals.Title>Confirmação de Pagamento</Modals.Title>
                                </Modals.Header>
                                <Modals.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                                    {paymentApproved ? (
                                        <div style={{ textAlign: 'center' }}>
                                            <Typography sx={{ textAlign: 'center', paddingBottom: '10px' }}>
                                                {progressValue < 100
                                                    ? "Aguarde, gerando documento."
                                                    : `Redirecionando em ${Math.ceil((5000 - (progressValue - 100) * 100) / 1000)}...`}
                                            </Typography>
                                            <LinearProgress variant="determinate" value={progressValue} sx={{ height: '5px', borderRadius: '3px', marginBottom: '40px' }} />
                                            <p>Obrigado pela confiança na <b>Atento Medicina de Trabalho LTDA.</b></p>
                                        </div>
                                    ) : (
                                        <>  <div style={{ textAlign: 'center' }}>
                                            <p>
                                                Para finalizar o processo de reaproveitamento, é necessário efetuar o pagamento do valor correspondente a esse serviço.
                                                Por favor, realize o pagamento para concluir o reaproveitamento e garantir que todos os procedimentos sejam devidamente finalizados.
                                                Agradecemos pela sua compreensão e cooperação.
                                            </p>
                                            <p style={{ fontSize: '15px' }}><b>Atento Medicina do Trabalho LTDA</b>
                                                <br />
                                                Valor: <b>R$ {descontoTotal ? '0,00' : valorInicialTotal}</b></p>
                                        </div>
                                            {qrCode ? (
                                                <img src={`data:image/png;base64,${qrCode}`} className='qrCode' alt="QR Code" />
                                            ) : (
                                                <p>Carregando QR Code...</p>
                                            )}
                                        </>
                                    )}
                                </Modals.Body>
                                <Modals.Footer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                </Modals.Footer>
                            </Modals>

                            <AlertMessage
                                show={alert.show}
                                message={alert.message}
                                variant={alert.variant}
                                onClose={() => setAlert({ ...alert, show: false })}
                            />
                        </>
                    )}
                </CardContent>
            </div>
        </>
    )


}